var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cpt-home-task_count w300"},[_c('div',{staticClass:"echart-view",class:_vm.RotationPieData.name})])}
var staticRenderFns = []

export { render, staticRenderFns }